import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userLogin } from 'react-admin';
import { environmentValues, getCookie, checkState } from '../App.js';

const fetchToken = async (body) => {
    const env = environmentValues();
    const tokenUrl = `${env.authUrl}/connect/token`

    const res = await fetch(tokenUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
    });

    if (res.ok) {
        const body = await res.json();

        const expires = new Date(Date.now() + body.expires_in * 1000);
        document.cookie = `token=${body.access_token}; expires=${expires.toUTCString()}; secure; path=/`;
        localStorage.setItem('refresh_token', body.refresh_token);
        console.log('Saved cookie');

        checkState();

        return body.access_token;
    }
}

export const checkRefreshToken = async () => {
    const env = environmentValues();

    const refresh_token = localStorage.getItem('refresh_token');
    if (refresh_token !== null) {
        console.log('Refreshing token');
        const result_token = await fetchToken(new URLSearchParams({
            grant_type: "refresh_token",
            refresh_token: refresh_token,
            client_id: env.clientId,
        }));

        if (result_token) {
            return result_token;
        } else {
            console.log('Failed to refresh token');
        }
    }
}

let refreshPromise = null;
export const checkRefreshTokensOnce = () => {
    if (!refreshPromise) {
        refreshPromise = checkRefreshToken()
            .then(() => {
                refreshPromise = null;
                Promise.resolve();
            })
            .catch(() => {
                refreshPromise = null;
                Promise.reject({ redirectTo: window.location.href });
            });
    }
    return refreshPromise;
}

class LoginRedirect extends Component {
    async componentDidMount() {

        const tokenFlow = async () => {
            const env = environmentValues();
            const searchParams = new URLSearchParams(window.location.search)

            const existing_token = getCookie('token');
            if (existing_token) {
                console.log('Found token in cookies');
                return existing_token;
            }

            const refreshed_token = await checkRefreshToken();
            if (refreshed_token) {
                return refreshed_token;
            }

            let code = searchParams.get('code');
            if (code === null) {
                console.log('connect/authorize');
                const loginUrl = `${env.authUrl}/connect/authorize`;
                // const title = encodeURIComponent('Integrations Engine');
                let returnUrl = window.location.href;
                returnUrl = btoa(returnUrl);

                function base64URLEncode(str: string): string {
                    const b64 = btoa(str);
                    const encoded = b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
                    return encoded;
                }

                const randomCode = () => {
                    let array = new Uint8Array(32);
                    array = crypto.getRandomValues(array);
                    return String.fromCharCode.apply(null, Array.from(array));
                }

                const sha256 = async (str: string): Promise<string> => {
                    const hashArray = await crypto.subtle.digest(
                        { name: "SHA-256" },
                        new TextEncoder().encode(str)
                    );
                    const uIntArray = new Uint8Array(hashArray);
                    const numberArray = Array.from(uIntArray);
                    const hashString = String.fromCharCode.apply(null, numberArray);

                    return base64URLEncode(hashString);
                };

                const codeVerifier = base64URLEncode(randomCode());
                const codeChallenge = await sha256(codeVerifier);

                localStorage.setItem("codeVerifier", codeVerifier);

                let state = searchParams.get('state');

                const params = new URLSearchParams();
                params.append("client_id", env.clientId);
                params.append("response_type", "code");
                params.append('scope', 'offline_access');
                params.append("code_challenge", codeChallenge);
                params.append("code_challenge_method", "S256");
                params.append("redirect_uri", env.redirectUri);
                if (state) {
                    params.append("state", state);
                }

                const navUrl = `${loginUrl}?${params.toString()}`;
                window.location.href = navUrl;

                return undefined;
            } else {
                console.log('connect/token');
                const codeVerifier = localStorage.getItem("codeVerifier");
                if (!codeVerifier) {
                    console.error('CodeVerifier was not found in localStorage');
                    return undefined;
                }

                const result_token = await fetchToken(new URLSearchParams({
                    grant_type: "authorization_code",
                    code,
                    redirect_uri: env.redirectUri,
                    client_id: env.clientId,
                    code_verifier: codeVerifier,
                }));

                return result_token;
            }
        }

        const token = await tokenFlow();

        console.log('Final token:');
        console.log(token);

        //debugger
        this.props.userLogin(token);
    }

    render() {
        return (
            <></>
        );
    }
};

export default connect(undefined, { userLogin })(LoginRedirect);